import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { getUserWarranty, fetchUserWarranty, getIsLoadedUserWarranty } from '@entities/Warranty';
import { SkeletonLoading, TypeAlertInfo, AlertInfo } from '@app/shared';
import { Warranty } from '@entities/Warranty/module/types/userWarrantySchema';
import { getDateBySeconds } from '@sharedHelpers/getDateBySeconds';
import { WrapperList } from '@app/shared/ui/WrapperList';
import { TitleList } from '@app/shared/ui/WrapperList/TitleList';
import { sortList } from '@app/shared/helpers/sortList';

import styles from './WarrantyUser.module.scss';

export const WarrantyUser = ({ title }) => {
  const dispatch = useAppDispatch();
  const warranties = useAppSelector(getUserWarranty);
  const isLoaded = useAppSelector(getIsLoadedUserWarranty);

  useEffect(() => {
    if (!isLoaded && !warranties.length) {
      dispatch(fetchUserWarranty());
    }
  }, []);

  if (!isLoaded) {
    return <WarrantyUser.Skeleton />;
  }

  return (
    <>
      <TitleList title={title} text="Действующие гарантии" />
      {!warranties.length && (
        <AlertInfo
          className={styles.Notificate}
          type={TypeAlertInfo.Info}
          link={'https://koleso.ru/garantii/rasshirennaya-garantiya-koleso_1/'}
        >
          У вас нет действующих гарантий. Что такое расширенная гарантия?
        </AlertInfo>
      )}
      <div className={styles.Wrapper}>
        {sortList(warranties).map((warranty, index) => {
          return <WarrantyUser.WarrantyCard key={index} {...warranty} />;
        })}
      </div>
    </>
  );
};

WarrantyUser.WarrantyCard = function WarrantyCard({ status, number, dataStart, dataEnd, car, brand }: Warranty) {
  return (
    <WrapperList className={styles.WrapperList} title="Действующие гарантии" text={`№ ${number}`} status={status} active={true}>
      <div className={styles.Content}>
        {brand && (
          <div>
            <div>Комплект шин: </div>
            <div className={styles.Text}>{brand}</div>
          </div>
        )}
        {dataStart && dataEnd && (
          <div>
            <div>Сроки гарании: </div>
            {Boolean(dataStart) && Boolean(dataEnd) && (
              <div className={styles.Text}>
                {getDateBySeconds(dataStart)} - {getDateBySeconds(dataEnd)}
              </div>
            )}
          </div>
        )}
        {car && (
          <div>
            <div>Автомобиль: </div>
            <div className={styles.Text}>{car}</div>
          </div>
        )}
      </div>
    </WrapperList>
  );
};

WarrantyUser.Skeleton = function Skeleton() {
  return (
    <div className={styles.Wrapper}>
      <SkeletonLoading width={'100%'} height={'161px'} />
      <SkeletonLoading width={'100%'} height={'161px'} />
    </div>
  );
};
